var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileBgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 675 900",
    width: 675,
    height: 900,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 675,
    height: 900,
    fill: "#001122"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#777d88",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#001122",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#777d88",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#777d88",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#777d88",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#001122",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(675, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 506.3C-56 467.1 -112 427.9 -165.7 400C-219.4 372.2 -270.9 355.8 -325.3 325.3C-379.7 294.8 -437.1 250.3 -467.7 193.7C-498.4 137.2 -502.3 68.6 -506.2 0L0 0Z",
    fill: "#3a4452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 337.5C-37.3 311.4 -74.7 285.2 -110.5 266.7C-146.3 248.1 -180.6 237.2 -216.8 216.8C-253.1 196.5 -291.4 166.9 -311.8 129.2C-332.2 91.5 -334.9 45.7 -337.5 0L0 0Z",
    fill: "#b9bcc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 168.8C-18.7 155.7 -37.3 142.6 -55.2 133.3C-73.1 124.1 -90.3 118.6 -108.4 108.4C-126.6 98.3 -145.7 83.4 -155.9 64.6C-166.1 45.7 -167.4 22.9 -168.7 0L0 0Z",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -506.2C72.3 -501.7 144.7 -497.1 189.8 -458.2C234.9 -419.4 252.8 -346.3 301.2 -301.2C349.6 -256.2 428.5 -239.3 467.7 -193.7C507 -148.2 506.6 -74.1 506.3 0L0 0Z",
    fill: "#3a4452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -337.5C48.2 -334.4 96.5 -331.4 126.5 -305.5C156.6 -279.6 168.6 -230.8 200.8 -200.8C233.1 -170.8 285.6 -159.5 311.8 -129.2C338 -98.8 337.7 -49.4 337.5 0L0 0Z",
    fill: "#b9bcc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -168.7C24.1 -167.2 48.2 -165.7 63.3 -152.7C78.3 -139.8 84.3 -115.4 100.4 -100.4C116.5 -85.4 142.8 -79.8 155.9 -64.6C169 -49.4 168.9 -24.7 168.8 0L0 0Z",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBgDark);
export default __webpack_public_path__ + "static/media/mobile_bg_dark.c17937b68dae3fa6a2ce339aa8f0685b.svg";
export { ForwardRef as ReactComponent };